import { render, staticRenderFns } from "./AdminMaster.vue?vue&type=template&id=190bbc8e&scoped=true&"
import script from "./AdminMaster.vue?vue&type=script&lang=js&"
export * from "./AdminMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190bbc8e",
  null
  
)

export default component.exports